
import { Salutations } from './salutations';
import { CustomerAddressTranslationsService, SalutationsTranslationService } from 'src/app/shared/translations';


/**
 * Blueprint for the address object.
 */
export class Address {
  public id: number;
  public street: string;
  public city: string;
  public company: string;
  public postalCode: string;
  public firstName: string;
  public lastName: string;
  public country: string;
  public type: string;
  public salutation: Salutations;
  public title: string;

  public types: Array<any> = [
    { value: 'standard', type: this.typeTranslations.i18nAddressTypeStandard },
    { value: 'delivery', type: this.typeTranslations.i18nAddressTypeDelivery },
    { value: 'additional', type: this.typeTranslations.i18nAddressTypeAdditional }
  ];

  constructor(
    address: any,
    private typeTranslations: CustomerAddressTranslationsService,
    private salutationTranslations: SalutationsTranslationService
  ) {
    this.id = address.id;
    this.street = address.street;
    this.city = address.city;
    this.company = address.company;
    this.postalCode = address.postalCode;
    this.firstName = address.firstName;
    this.lastName = address.lastName;
    this.country = address.country;
    this.type = address.type;
    this.title = address.title;

    this.salutation = new Salutations(address.salutation, this.salutationTranslations);
  }

  public get isStandard(): boolean {
    return this.type === 'standard';
  }

  public get translatedType(): string {
    const translatedType = this.types.find(type => this.type === type.value);
    return translatedType.type;
  }
}
